import React from 'react';
import { whySpareFootContent } from './StaticContent';
import { Image } from 'components/core/Image';
import { FAQ } from 'components/core/FAQ';
import { Paragraph, H2, H4 } from 'components/core/Typography';

import './WhySpareFootSection.scss';

export const WhySpareFootSection = () => {
	return (
		<div className="why-sparefoot-section" id='why-sparefoot'>
			<div className="background-container">
				<div className="header-content">
					<H2
						size="xlarge"
						weight="bold"
					>
						Why SpareFoot?
					</H2>

					<div className="top-card-row">
						{whySpareFootContent.topCards.map((card, index) => {
							return (
								<div
									key={index}
									className="why-sparefoot-card"
								>
									<div className="why-sparefoot-card-image">
										<Image
											src={card.image}
											height={40}
											width={40}
											alt={card.text}
										/>
									</div>
									<Paragraph
										color="black"
										weight="bold"
									>
										{card.text}
									</Paragraph>
								</div>
							);
						})}
					</div>
				</div>
			</div>

			<div className="accordion-column">
				<H4
					size="tall"
					weight="bold"
				>
					Explore a variety of storage unit types and amenities:
				</H4>

				<div className="accordion-row">
					<div>
						<FAQ
							className="plp-accordions"
							content={whySpareFootContent.faqContent.slice(0, 5)}
							noHeader={true}
						/>
					</div>

					<div>
						<FAQ
							className="plp-accordions"
							content={whySpareFootContent.faqContent.slice(5)}
							noHeader={true}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WhySpareFootSection;
